import React from 'react';
import kidneyComparisonImage from '../assets/image1.png';

const About = () => {
  return (
    <section className="section">
      <div className="container about-content">
        <div className="about-text">
          <h2>About PKD</h2>
          <p>
            Polycystic kidney disease is a genetic disease characterized by
            multiple fluid filled cavities called ‘cysts’, studded in the kidneys.
          </p>
          <p>
            These cysts gradually grow and eventually fill the entire kidney,
            leaving very little number of kidney filters called nephrons.
          </p>
          <p>
            As the number of nephrons reduces, kidney function deteriorates,
            eventually leading to kidney failure.
          </p>
        </div>
        <div className="about-image">
          <img src={kidneyComparisonImage} alt="Illustration comparing a normal kidney to a polycystic kidney" />
        </div>
      </div>
    </section>
  );
};

export default About;